import { useTranslation } from "react-i18next";
import { usePhoneNumberSchema, yupEmail, yupEmailRequired } from "src/utils";
import * as Yup from "yup";

export const useSignatureValidationSchema = () => {
  const phoneSchema = usePhoneNumberSchema({ isRequired: true });
  const { t } = useTranslation();

  const schema = Yup.object().shape({
    phoneNumber: phoneSchema,
    email: yupEmailRequired,
  });

  return { schema };
};
